// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PLikeOutlinedSvg from "@fishx/icons-svg/es/asn/PLikeOutlined";
import FishxIcon from '../components/FishxIcon';

var PLikeOutlined = function PLikeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PLikeOutlinedSvg
  }));
};

PLikeOutlined.displayName = 'PLikeOutlined';
export default React.forwardRef(PLikeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PLikeOutlined.js
// module id = 3488
// module chunks = 0